export function isPumpFunSoundMuted(): boolean {
    return localStorage.getItem(isPumpFunSoundMuted.key) === 'false';
}

isPumpFunSoundMuted.key = 'pumpfunSoundEnabled' as const;

export function isBonkSoundMuted(): boolean {
    return localStorage.getItem(isBonkSoundMuted.key) === 'false';
}
isBonkSoundMuted.key = 'bonkSoundEnabled' as const;
